// @flow
import * as React from "react";
import { Field, Form, Formik } from "formik";
import Box from "@material-ui/core/Box";
import {CheckboxWithLabel, TextField} from "formik-material-ui";
import { Button, LinearProgress } from "@material-ui/core";
import * as Yup from "yup";
import { v4 as uuid } from "uuid";
import { useFirestore } from "reactfire";
import { useSnackbar } from "notistack";
import Grid from "@material-ui/core/Grid";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Benötigte Angabe"),
});

const fields = [
  {
    name: "name",
    type: "text",
    label: "Name",
  },
  {
    name: "visitorsAllowed",
    type: "checkbox",
    Label: { label: "Zuschauer erlaubt" },
    component: CheckboxWithLabel,
  },
];

function AdminAddTeam() {
  const firestore = useFirestore();
  const teamsRef = firestore.collection("teams");
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Formik
      initialValues={{
        name: "",
        visitorsAllowed: false,
      }}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        const id = uuid();
        await teamsRef
          .doc(id)
          .set({ ...values, iconString: "sgcoe.svg", id })
          .then(() => {
            enqueueSnackbar("Team hinzugefügt", { variant: "success" });
          })
          .catch((error) => {
            console.error(error);
            enqueueSnackbar(error.message || error, { variant: "error" });
          });
      }}
    >
      {({ submitForm, isSubmitting, resetForm }) => (
        <Form style={{ width: "100%" }}>
          {fields.map(({ name, ...other }) => (
            <Box mb={1} key={name}>
              <Field
                component={TextField}
                name={name}
                variant="filled"
                {...other}
              />
            </Box>
          ))}
          {isSubmitting ? (
            <LinearProgress mb={1} />
          ) : (
            <Grid container justify="space-between">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  onClick={submitForm}
                  type="submit"
                >
                  Hinzufügen
                </Button>
              </Grid>
              <Grid item>
                <Button onClick={resetForm}>Reset</Button>
              </Grid>
            </Grid>
          )}
        </Form>
      )}
    </Formik>
  );
}

export default AdminAddTeam;
